import { useAdminTeamsEmitter } from "@/hooks/useAdminTeamsEvents";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminTeamDTO, AdminUserDTO } from "@shaarp/common";
import { useState } from "react";
import { UserSelector } from "../admin/user-selector";
import { ButtonLoading } from "../button-loading";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { useToast, useToastError } from "../ui/use-toast";

export const DialogAdminTeamReferral = ({
  team,
  open,
  onClose,
}: {
  team: AdminTeamDTO;
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const api = useApi();
  const toastError = useToastError();
  const { toast } = useToast();
  const { refreshTeams } = useAdminTeamsEmitter();

  const [isLoading, setIsLoading] = useState(false);
  const [referralSelected, setReferralSelected] = useState<AdminUserDTO | null>(
    null
  );

  const save = async () => {
    setIsLoading(true);
    try {
      await api.post(`/admin/team/${team.id}/referral`, {
        referralUserId: referralSelected?.id || null,
      });
      refreshTeams();
      toast({
        variant: "default",
        title: t(
          "admin.dataTableAdminTeams.dialogs.referral.toast.success.title"
        ),
        description: t(
          "admin.dataTableAdminTeams.dialogs.referral.toast.success.description"
        ),
      });

      onClose();
    } catch (error) {
      toastError({
        description: t(
          "admin.dataTableAdminTeams.dialogs.referral.toast.error.description"
        ),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("admin.dataTableAdminTeams.dialogs.referral.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <UserSelector
              onSelect={(user) => setReferralSelected(user)}
              defaultSelectedUserId={team.invitedBy}
            />
          </div>
        </div>
        <DialogFooter>
          <ButtonLoading onClick={save} isLoading={isLoading}>
            {t("admin.dataTableAdminTeams.dialogs.referral.save")}
          </ButtonLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
